import axios, { AxiosResponse } from "axios";

import { ShipmentType, CommonConstants } from "@assets/constants";
import { PortTypes, SamskipAPIResponse } from "@assets/types";

const SamskipAPI = process.env.SamskipAPI;

class PortService {
  getPorts = async () => {
    const res: AxiosResponse<SamskipAPIResponse<PortTypes.Port[]>> =
      await axios.get(`${SamskipAPI}/ports`);
    return res.data.ReturnItem.Data;
  };

  getPort = async (pointCode: string) => {
    const res: AxiosResponse<SamskipAPIResponse<PortTypes.Port>> =
      await axios.get(`${SamskipAPI}/ports/${encodeURIComponent(pointCode)}`);
    return res.data.ReturnItem.Data;
  };

  searchPorts = async (
    searchString: string | null = null,
    country: string | null = null
  ) => {
    const res: AxiosResponse<SamskipAPIResponse<PortTypes.Port[]>> =
      await axios.get(`${SamskipAPI}/ports/search`, {
        params: {
          searchString: searchString,
          country: country,
        },
      });
    return res.data.ReturnItem.Data;
  };

  getPortForPool = async (
    cityPointCode: string,
    portType: "POD" | "POL",
    shippingType: ShipmentType
  ) => {
    const res: AxiosResponse<SamskipAPIResponse<PortTypes.Port>> =
      await axios.get(
        `${SamskipAPI}/pools/${encodeURIComponent(cityPointCode)}/port`,
        {
          params: {
            isPortOfLoad: portType === CommonConstants.INCOTERM_POINT.POL,
            shippingType: shippingType,
          },
        }
      );
    return res.data.ReturnItem.Data;
  };
}

export default new PortService();
